import { Injectable } from '@angular/core';
import { combineQueries } from '@datorama/akita';
import { DateTimeService } from '@y42/date-time';
import { JobQuery } from '@y42/job';
import { OrgUserQuery } from '@y42/org-user/state';
import { map } from 'rxjs';
import { ExportTriggerStoreQuery } from '../export-trigger/export-trigger.store-query';
import { ExportTriggerJobState, ExportTriggerJobUIModel } from './export-trigger-job.model';
import { ExportTriggerJobStore } from './export-trigger-job.store';

@Injectable({ providedIn: 'root' })
export class ExportTriggerJobQuery extends JobQuery<ExportTriggerJobState, ExportTriggerJobUIModel> {
  constructor(
    store: ExportTriggerJobStore,
    dateTimeService: DateTimeService,
    orgUserQuery: OrgUserQuery,
    private readonly parentQuery: ExportTriggerStoreQuery,
  ) {
    super(store, dateTimeService, orgUserQuery, (storeModel) => {
      return {
        ...storeModel,
        triggeredBy: this.getTriggeredBy(storeModel),
        exportTrigger: this.parentQuery.getEntity(storeModel.path ?? '')!,
        settingsValid: true,
        settingsValidationResult: undefined,
      };
    });
  }

  protected readonly allJobs$ = combineQueries([
    this.selectAll(),
    this.parentQuery.selectActive(),
    this.orgUserQuery.selectAll(),
  ]).pipe(map(([items]) => items.map((item) => this.toUIModel(item))));
}
